import actions from "../actions/initialSetting";
// import actions from "../actions/test";
// import getters from "@/store/getters/insUserInfoGetter";
/**
 * [INS] InseUserInfo DATA
 */
export default {
  state: {
    initialSetting: {}
  },
  actions
};
